<template>
  <section class="content" style="width: 80%;">
    <!-- Default box -->
    <div class="row">
      <div class="col-md-4 download-pdf">
      <button class="btn btn-success btn-block" id="download" @click="Download()">Download PDF</button>

      </div>
    </div>
    <div class="box fontsize">
      <!-- <div class="box-header with-border">
        <h3 class="box-title">Settings</h3>
      </div> -->
      <div class="box-body" id="html-template" style="height: 100%;min-height: 700px;">
        <!-- start tab -->
        <div class="row fontsize" id="pdfdocument">
              <div class="col-sm-12">
                <div>
                  <!-- <div class="box-header with-border mt-10" style="padding: 11px;text-align: center;font-size: 16px;">
                    <h4 class="box-title"><b>INTERVIEW EVALUATION SHEET</b></h4><br>
                    <h4 class="box-title">{{postDetails.role_name}}</h4><br>
                    <h4 class="box-title">Interactive Technical Assessment</h4>
                  </div> -->
                  <div class="box-header with-border mt-10" style="padding: 11px;text-align: center;">
                    <div class="box-title fontsize"><b>Interactive Technical Assessment</b></div><br>
                  </div>
                  <div class="box-header with-border" style="background-color: #f1f1f1;">
                    <div class="row p-5">
                          <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">Candidate's Name:</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.candidate_name + ' ' + scheduleDetails.candidate_lastname}}</span>
                          </div>
                          <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">Role:</span>
                            <span class="direct-chat-name col-md-6">{{postDetails.job_tittle}}</span>
                          </div>
                          <!-- <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">Candidate Last Name</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.candidate_lastname}}</span>
                          </div> -->
                    </div>
                    <div class="row p-5">
                      <div class="col-md-6">
                        <span class="direct-chat-timestamp col-md-6">Panelist's Name:</span>
                        <span class="direct-chat-name col-md-6">{{scheduleDetails.interviewer_firstname}} {{scheduleDetails.interviewer_lastname}}</span>
                      </div>
                      <div class="col-md-6">
                          <span class="direct-chat-timestamp col-md-6">Date(MM/DD/YY):</span>
                          <span class="direct-chat-name col-md-6">{{scheduleDetails.schedule_date | formatDate}}</span>
                          </div>
                    </div>
                    <div class="row p-5">
                      <div class="col-md-6">
                          <span class="direct-chat-timestamp col-md-6">Recruiter's Name:</span>
                          <span class="direct-chat-name col-md-6">{{scheduleDetails.org_firstname}} {{scheduleDetails.org_lastname}}</span>
                          </div>
                          <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">Name of the Client:</span>
                            <span class="direct-chat-name col-md-6" v-if="postDetails.client_name != ''">{{postDetails.client_name}}</span>
                            <span class="direct-chat-name col-md-6" v-if="postDetails.client_name == ''">NA</span>
                          </div>
                    </div>
                    <!-- <div class="row p-5"> -->
                          <!-- <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">ATS Number</span>
                            <span class="direct-chat-name col-md-6" v-if="postDetails.bull_horn_number != ''">{{postDetails.bull_horn_number}}</span>
                            <span class="direct-chat-name col-md-6" v-if="postDetails.bull_horn_number == ''">NA</span>
                          </div> -->

                    <!-- </div> -->
                  </div>
                  <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitFeedback" novalidate>
                    <div class="col-md-12">
                      <div class="form-row mt-2">
                          <p><br></p>
                          <div class="form-group">
                            <u><b>Candidate No Show</b></u>
                            <p>&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input disabled v-model="candidateshowVal" type="radio" name="radio0" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input disabled type="radio" v-model="candidateshowVal" name="radio0" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div>
                      </div>
                      <div class="form-row">
                        <p><br></p>
                          <div class="form-group">
                            <u><b>Proxy</b></u>
                            <p>&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input v-model="proxyVal" disabled type="radio" name="radio1" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input v-model="proxyVal" disabled type="radio" name="radio1" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div>
                        <!-- <div class="form-group">
                              <u><b>Proxy </b></u><br>
                            <label class="container"> Yes<input checked v-model="proxyVal" disabled type="radio" name="radio1" value="Yes">
                              <span class="checkmark"></span>
                            </label>
                            <label class="container">No<input checked v-model="proxyVal" disabled type="radio" name="radio1" value="No">
                              <span class="checkmark"></span>
                            </label>
                        </div> -->
                        <div class="form-group">
                            <label> Mode of Interview</label>
                              <div class="form-select">
                                <select disabled class="form-control is-valid" id="interview" v-model="form.interview" v-bind:class="{  'is-invalid': !chkState('interview')}">
                                  <option value=''>Interview *</option>
                                  <option value="Zoom">Zoom</option>
                                  <option value="WebEx">WebEx</option>
                                  <option value="In Person">In Person</option>
                                  <option value="Hangout Teams">Hangout Teams</option>
                                  <option value="Skype" >Skype</option>
                                  <option value="Microsoft Teams">Microsoft Teams</option>
                                  <option value="ScreenIt">ScreenIt</option>
                                </select>
                                <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                <div v-if="this.clientError">
                                <p v-if="!$v.form.interview.required" class="login-alert-msg error-content">*Select Interview</p>
                              </div></div>
                          </div>
                          <div class="form-group">
                            <label>Level</label>
                              <div class="form-select">
                                <select disabled v-model="form.level" class="form-control" v-bind:class="{ 'is-invalid': !chkState('level') }">
                                  <option value="Junior"> Junior</option>
                                  <option value="Mid"> Mid</option>
                                  <option value="Senior"> Senior</option>
                                  <option value="Lead"> Lead</option>
                                  <option value="Architect"> Architect</option>
                                </select>
                                <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                 <div v-if="this.clientError">
                                <p v-if="!$v.form.level.required" class="login-alert-msg error-content">* Select level</p>
                              </div>
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                        <u><b>Scoring Definitions</b></u>
                        <!-- <p>1. <b>Lacks overall competency, needs improvement (Entry-level) - 1 / 1.5</b></p>
                        <p>2. <b>Limited competency, scalable in shorter term (Junior level)  -  2 / 2.5</b></p>
                        <p>3. <b>Appreciable and broader competency, rapidly scalable (Mid / Senior level) - 3 / 3.5</b></p>
                        <p>4. <b>Demonstrated competency, consistently adaptive (Lead / Architect level) - 4 / 4.5</b></p>
                        <p>5. <b>Proficient competency, and progressive (SME level) - 5</b></p> -->
                        <div class="col-md-12"><b><span class="col-md-2">1 to 1.5</span><span class="col-md-1">-</span><span class="col-md-8">Lacks overall competency, needs improvement (Rejected)</span></b></div>
                        <div class="col-md-12"><b><span class="col-md-2">2 to 2.5</span><span class="col-md-1">-</span><span class="col-md-8">Limited competency, scalable in shorter term (Junior level)</span></b></div>
                        <div class="col-md-12"><b><span class="col-md-2">3 to 3.5</span><span class="col-md-1">-</span><span class="col-md-8">Appreciable and broader competency, rapidly scalable (Mid / Senior level)</span></b></div>
                        <div class="col-md-12"><b><span class="col-md-2">4 to 4.5</span><span class="col-md-1">-</span><span class="col-md-8">Demonstrated competency, consistently adaptive (Lead / Architect level)</span></b></div>
                        <div class="col-md-12"><b><span class="col-md-2">5</span><span class="col-md-1">-</span><span class="col-md-8">Proficient competency, and progressive (SME level)</span></b></div>
                    </div>
                    <div class="col-md-12 mt-5">
                        <u class="mt-5"><b>Technical Evaluation</b></u>
                        <p class="mt-5"><b>Please evaluate candidate’s competency on a scale of 1 to 5 (1 Lowest, 5 highest)</b></p>
                    </div>
                    <div class="col-md-12">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Required Technical Skills</th>
                            <th>Rating</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(column, index) in tskills" :key="index">
                             <td>{{column.skill_name}}</td>
                            <td><star-rating increment="0.5" read-only="true" :show-rating="false" readonl active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating></td>
                              <td>
                                {{column.comments}}
                                <p v-if="column.required" class="login-alert-msg error-content">* Enter comments</p>
                              </td>
                          </tr>
                          <!-- post primary skills -->
                          <tr v-for="(column, index) in postSkills" :key="index">
                             <td>{{column.skill_name}}</td>
                            <td><star-rating increment="0.5" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.rating" v-bind:star-size="20" ></star-rating></td>
                              <td>
                                {{column.comments}}
                                <!-- <b-form-textarea @change="tsChange(index)"  v-model.lazy.trim="column.comments" class="textarea" rows="1" placeholder="Enter your comments"></b-form-textarea> -->
                                <p v-if="column.required" class="login-alert-msg error-content">* Enter comments</p>
                              </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <div class="col-md-12 newPage"></div>
                    <div class="col-md-12 after"></div> -->
                    <div class="col-md-12">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Preferred Technical Skills</th>
                            <th>Rating Scale</th>
                            <th>Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(column, index) in pfskills" :key="index">
                             <td>{{column.skill_name}}</td>
                            <td><star-rating  increment="0.5" read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating></td>
                              <td>
                                {{column.comments}}
                                <p v-if="column.required" class="login-alert-msg error-content">* Enter comments</p>
                              </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12 newPage"></div>
                    <div class="col-md-12 after"></div>
                    <div v-if="manLeadskills.length > 0" class="col-md-12">
                        <u><b>Mandatory Skills for Lead expertise: (Do mention “Not applicable” if so)</b></u>
                    </div>
                    <div v-if="manLeadskills.length > 0" class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Topics</th>
                            <th>Rating Score</th>
                            <th>Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(column, index) in manLeadskills" :key="index">
                            <td>{{column.skill_name}}</td>
                            <td><star-rating read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating></td>
                            <td>
                              {{column.comments}}
                              <p v-if="column.required" class="login-alert-msg error-content">* Enter comments</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-if="manskills.length > 0" class="col-md-12">
                        <u><b>Mandatory skills for “computational / analytical” competency: (Do mention “Not applicable” as appropriate)</b></u>
                    </div>
                    <div v-if="manskills.length > 0" class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Topics</th>
                            <th>Rating Score</th>
                            <th>Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(column, index) in manskills" :key="index">
                            <td>{{column.skill_name}}</td>
                            <td><star-rating read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating></td>
                            <td>
                              {{column.comments}}
                              <p v-if="column.required" class="login-alert-msg error-content">* Enter comments</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12">
                      <u><b>Level of Experience</b></u>
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Category of levels</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><b>Junior</b></td>
                            <td>{{$v.form.jun_level.$model}}</td>
                          </tr>
                          <tr>
                            <td><b>Mid</b></td>
                            <td>{{$v.form.mid_level.$model}}</td>
                          </tr>
                          <tr>
                            <td><b>Senior</b></td>
                            <td>{{$v.form.sen_level.$model}}</td>
                          </tr>
                          <tr>
                            <td><b>Lead</b></td>
                            <td>{{$v.form.lead.$model}}</td>
                          </tr>
                          <tr>
                            <td><b>Architect</b></td>
                            <td>{{$v.form.architect_level.$model}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12">
                        <u><b>Communication level / expertise (Defined standard of oral articulation level)</b></u><br>
                        <p><label class="container"> 1. <b>Speaks with limited fluency, irregular grammar and carries a distinct accent</b><input v-model="communication_level" type="radio" disabled name="radio" value="Speaks with limited fluency, irregular grammar and carries a distinct accent">
                       <span class="checkmark"></span>
                       </label></p>
                        <p><label class="container">2. <b>Speaks with comfortable fluency, agreeable grammar, has noticeable accent</b><input v-model="communication_level" type="radio" disabled name="radio" value="Speaks with comfortable fluency, agreeable grammar, has noticeable accent">
                        <span class="checkmark"></span>
                            </label></p>
                        <p><label class="container" >3. <b>Speaks with acceptable finesse/ accurate grammar and has no accent</b><input v-model="communication_level" type="radio" name="radio" disabled value="Speaks with acceptable finesse/ accurate grammar and has no accent">
                          <span class="checkmark"></span>
                         </label></p>
                        <p><label class="container">4. <b>Speaks with polish / finesse. Demonstrates confidence in presenting the credentials with ease</b><input v-model="communication_level" disabled type="radio" name="radio" value="Speaks with polish / finesse. Demonstrates confidence in presenting the credentials with ease">
                          <span class="checkmark"></span>
                         </label></p><br>
                    </div>
                    <!-- <div class="col-md-12">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Non-Technical Evaluation</th>
                            <th>Rating</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Communication Level</td>
                            <td><star-rating increment="0.5" read-only="true" v-model="rating" @rating-selected ="setRating" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <td>{{$v.form.commun_level_comments.$model}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->
                    <div class="col-md-12">
                      <u><b>Observations:</b></u>
                      <table class="table table-bordered">
                        <tbody>
                          <tr>
                            <td>Communication Level</td>
                            <td>(Ref one of the four listed above)</td>
                          </tr>
                          <tr>
                            <td>Technical Observation</td>
                            <td>{{$v.form.technical_obser.$model}}</td>
                          </tr>
                          <tr>
                            <td>Analytical and problem-solving Skills</td>
                            <td>{{$v.form.anal_prosolving.$model}}</td>
                          </tr>
                          <tr>
                            <td>Attitude / Aptitude demonstrated</td>
                            <td>{{$v.form.attitude.$model}}</td>
                          </tr>
                          <tr>
                            <td>Clarity of the answers provided</td>
                            <td>{{$v.form.clar_answer.$model}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12">
                      <u><b>Final Recommendation:</b></u>
                      <table class="table table-bordered">
                        <tbody>
                          <tr>
                            <td>Must Hire/Hire/Hold/Do not Hire</td>
                            <td>{{$v.form.final_recommendation.$model}}</td>
                          </tr>
                          <tr>
                            <td>Junior/ Mid/ Senior/ Lead/ Architect</td>
                            <td>{{$v.form.recommended_for.$model}}</td>
                          </tr>
                          <tr>
                            <td>Other Comments, if any:</td>
                            <td>{{$v.form.other_comments.$model}}</td>
                          </tr>
                          <tr>
                            <td><div class="form-group">
                            <u><b>Recommended?</b></u>
                            <p>&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input :checked="recommendedVal == 'Yes'" disabled type="radio" name="recommended" @change="onChangerecommended('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input :checked="recommendedVal == 'No'" type="radio" disabled name="recommended" @change="onChangerecommended('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12" v-if="schedule_codes.length > 0">
                      <u><b>TDD code:</b></u>
                      <div class="col-md-12" style="padding: 29px" v-for="v in schedule_codes" :key="v">
                        <div class="form-row">
                          <label>Tittle: {{v.title}}</label>
                        </div>
                        <div class="form-row">
                          <VueCodeEditor
                            :value="v.code"
                            @init="editorInit"
                            lang="javascript"
                            theme="monokai"
                            width="100%"
                            height="200px"
                            :options="{
                              enableBasicAutocompletion: true,
                              enableLiveAutocompletion: true,
                              fontSize: 14,
                              highlightActiveLine: true,
                              enableSnippets: true,
                              showLineNumbers: true,
                              tabSize: 2,
                              showPrintMargin: true,
                              showGutter: true,
                            }"
                            :commands="[
                                {
                                  name: 'save',
                                  bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                  exec: null,
                                  readOnly: true,
                                },
                            ]"
                            />
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-md-12" style="padding: 29px" v-if="schedule_codes.length > 0">
                      <div class="form-row" style="background-color: #cccccc69;padding: 7px;">
                        <label>Candidate's Programming Code</label>
                      </div>
                    </div>
                    <div class="col-md-12" style="padding: 29px" v-for="v in schedule_codes" :key="v">
                      <div class="form-row">
                        <label>Tittle: {{v.title}}</label>
                      </div>
                      <div class="form-row">
                         <VueCodeEditor
                          :value="v.code"
                          @init="editorInit"
                          lang="javascript"
                          theme="monokai"
                          width="100%"
                          height="200px"
                          :options="{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            fontSize: 14,
                            highlightActiveLine: true,
                            enableSnippets: true,
                            showLineNumbers: true,
                            tabSize: 2,
                            showPrintMargin: true,
                            showGutter: true,
                          }"
                          :commands="[
                              {
                                name: 'save',
                                bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                exec: null,
                                readOnly: true,
                              },
                          ]"
                          />
                      </div>
                    </div> -->
                    <div class="col-md-12">
                      <div class="form-row" v-if="feedbackDetail.candidate_profile">
                        <div class="form-group">
                          <label>Candidate’s photograph:</label>
                          <img :src="feedbackDetail.candidate_profile">
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group">
                          <img src="../../assets/img/acs-logo.png" style="width: 26%;padding-top: 40px;">
                        </div>
                      </div>
                    </div>
                    <br>
                    <br>
                    <div class="col-md-12"><p><br><br></p></div>
                 <div class="col-md-12"><p><br><br></p></div>
            </b-form>
                </div>
              </div>
            </div>
      </div>
        <!-- end tab -->
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
  </section>
</template>

<script>
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import * as Cookies from 'js-cookie'
import router from '../../router/index'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import StarRating from 'vue-star-rating'
import $ from 'jquery'
import VueCodeEditor from 'vue2-code-editor'
// import { HtmlToDocx } from 'html-docx'
// import Jspdf from 'jspdf'
import html2pdf from 'html2pdf.js'
// import { makePDF } from 'multi-page-html2pdf'
// import html2canvas from 'html2canvas'
// import { Carousel, Slide } from 'vue-carousel'
import moment from 'moment'
Vue.use(moment)
// Vue.user(HtmlToDocx)
const formShape = {
  level: '',
  interview: '',
  jun_level: '',
  mid_level: '',
  sen_level: '',
  lead: '',
  architect_level: '',
  commun_level_comments: '',
  technical_obser: '',
  anal_prosolving: '',
  attitude: '',
  clar_answer: '',
  recommended_for: '',
  final_recommendation: '',
  other_comments: '',
  TDD_code: '',
  client_name: ''
}
const formShape2 = {
  comments: '',
  comments2: '',
  comments3: '',
  comments4: ''
}
const formShape3 = {
  remarks: '',
  remarks2: '',
  remarks3: '',
  remarks4: '',
  remarks5: ''
}
export default {
  name: 'addFeedback',
  data () {
    return {
      form: Object.assign({}, formShape),
      form2: Object.assign({}, formShape2),
      form3: Object.assign({}, formShape3),
      picked: 'Speaks with limited fluency, irregular grammar and carries a distinct accent',
      files: [],
      communication_level: '',
      Files: [],
      pfskills: [],
      clientError: false,
      tskills: '',
      manskills: '',
      manLeadskills: '',
      rolelist: '',
      fid: '',
      sid: Cookies.get('sid'),
      comm_level_rating: 0,
      scheduleDetails: [],
      postDetails: [],
      feedbackDetail: [],
      postSkills: [],
      schedule_codes: [],
      schedule_id: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      proxyVal: '',
      recommendedVal: '',
      candidateshowVal: ''
    //   techskillta:[
    //    {
    //   textarea1: '',
    //    }
    //  ],
    //  manskillta:[
    //    {
    //   textarea: '',
    //    }
    //  ]
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      level: {
        required
      },
      interview: {
        required
      },
      jun_level: {
        required
      },
      mid_level: {
        required
      },
      sen_level: {
        required
      },
      lead: {
        required
      },
      architect_level: {
        required
      },
      commun_level_comments: {
        required
      },
      technical_obser: {
        required
      },
      anal_prosolving: {
        required
      },
      attitude: {
        required
      },
      clar_answer: {
        required
      },
      recommended_for: {
        required
      },
      final_recommendation: {
        required
      },
      other_comments: {
        required
      },
      TDD_code: {
        required
      },
      client_name: {}
    },
    form2: {
      comments: {
        required
      },
      comments2: {
        required
      },
      comments3: {
        required
      },
      comments4: {
        required
      }
    },
    form3: {
      remarks: {
        required
      },
      remarks2: {
        required
      },
      remarks3: {
        required
      },
      remarks4: {
        required
      },
      remarks5: {
        required
      }
    }
  },
  components: {
    VueCodeEditor, StarRating
  },
  created () {
    this.schedule_id = this.$route.params.id
    this.getFeedbackDetails()
    this.getFetchrolename()
    this.getscheduleDetails()
  },
  methods: {
    ExportToDoc (element, filename = '') {
      var header = '<html><head><title>Export HTML to Word Document with JavaScript</title></head><body>'
      var footer = '</body></html>'
      var html = header + document.getElementById(element).innerHTML + footer
      var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
      })
      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html)
      // Specify file name
      filename = 'document.docx'
      // Create download link element
      var downloadLink = document.createElement('a')
      document.body.appendChild(downloadLink)
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        // Create a link to the file
        downloadLink.href = url
        // Setting the file name
        downloadLink.download = filename
        // triggering the function
        downloadLink.click()
      }
      document.body.removeChild(downloadLink)
    },
    closeViolated () {
      $('#myModal').modal('hide')
    },
    Download () {
      // const data = Object.assign({}, this.$refs)
      // html2pdf(data.document, {
      //   margin: {
      //     bottom: 1
      //   },
      //   filename: 'document.pdf',
      //   image: {
      //     type: 'jpeg',
      //     quality: 2
      //   },
      //   html2canvas: {
      //     dpi: 300,
      //     letterRendering: true
      //   },
      //   jsPDF: {
      //     unit: 'in',
      //     format: 'letter',
      //     orientation: 'landscape'
      //   }
      // })
      // data.hide.setAttribute('hidden', 'hidden')
      const element = document.getElementById('pdfdocument')
      const opt = {
        margin: 1,
        filename: 'feedback.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 3 },
        pagebreak: { before: '.newPage', after: '.after', avoid: '.avoid' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }
      html2pdf().from(element).set(opt).save()
    },
    getscheduleDetails () {
      console.log(this.$route.params.id)
      axios.get(BaseURL + '/dashboard/get_schedule_detail/' + this.$route.params.id, this.config).then(response => {
        this.scheduleDetails = response.data.scheduleList[0]
        this.getPostDetails(this.scheduleDetails.post_id)
      }).catch(e => {
      })
    },
    getPostDetails (id) {
      axios.get(BaseURL + '/dashboard/get_post_details_web/' + id, this.config).then(response => {
        this.postDetails = response.data.postInfo[0]
      }).catch(e => {
      })
    },
    fileUpload (e) {
      console.log('file', e.target.files)
      this.files = e.target.files
      this.Files = e.target.files[0]
      console.log('Files', this.Files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
          if (e.target.files[k].size < '2000001') {
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      console.log(this.files)
      const formData = new FormData()

      formData.append('image', this.Files)
      axios.post(BaseURL + '/dashboard/upload_candidate_image/1',
        formData, this.config).then(response => {
        console.log(response)
      }).catch(e => {
        console.log(e)
      })
    },
    onChange (event) {
      this.picked = event.target.value
      console.log('this.picked', this.picked)
    },
    removeUploading (index) {
      this.Files = ''
      console.log(this.files)
    },
    changepass () {
      this.olderror = false
    },
    getdate (x) {
      const d = moment().add(x, 'days')
      return moment(d).format('DD MMM YYYY')
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    chkState2 (val) {
      const field = this.$v.form2[val]
      return !field.$dirty || !field.$invalid
    },
    chkState3 (val) {
      const field = this.$v.form3[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    removeElement (row) {
      const index = this.rows.indexOf(row)
      this.rows.splice(index, 1)
    },
    changecomments () {
      const len = this.$v.form2.comments.$model.length
      const c2len = this.$v.form2.comments2.$model.length
      const c3len = this.$v.form2.comments3.$model.length
      const c4len = this.$v.form2.comments4.$model.length
      console.log('len....', len)
      if (len < '1' || c2len < '1' || c3len < '1' || c4len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changeremarks () {
      const remlen = this.$v.form3.remarks.$model.length
      const rem2len = this.$v.form3.remarks2.$model.length
      const rem3len = this.$v.form3.remarks3.$model.length
      const rem4len = this.$v.form3.remarks4.$model.length
      const rem5len = this.$v.form3.remarks5.$model.length
      if (remlen < '1' || rem2len < '1' || rem3len < '1' || rem4len < '1' || rem5len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    setRating (rating) {
      this.comm_level_rating = rating
      console.log('this.rating', this.rating)
    },
    changeloecomments () {
      const junlen = this.$v.form.jun_level.$model.length
      const midlen = this.$v.form.mid_level.$model.length
      const senlen = this.$v.form.sen_level.$model.length
      const archlevel = this.$v.form.architect_level.$model.length

      if (junlen < '1' || midlen < '1' || senlen < '1' || archlevel < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changecommentsrecommen () {
      const crecommenlen = this.$v.form.technical_obser.$model.length
      const crecommenlen2len = this.$v.form.anal_prosolving.$model.length
      const crecommenlen3len = this.$v.form.attitude.$model.length
      const crecommenlen4len = this.$v.form.clar_answer.$model.length
      if (crecommenlen < '1' || crecommenlen2len < '1' || crecommenlen3len < '1' || crecommenlen4len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changefinalrecommen () {
      const recommendedlen = this.$v.form.recommended_for.$model.length
      const finalrecommendedlen = this.$v.form.final_recommendation.$model.length
      const othercommentslen = this.$v.form.other_comments.$model.length
      const tddcodelen = this.$v.form.TDD_code.$model.length

      if (recommendedlen < '1' || othercommentslen < '1' || tddcodelen < '1' || finalrecommendedlen < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changentcomments () {
      const communlevelcomment = this.$v.form.commun_level_comments.$model.length
      if (communlevelcomment < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    tsChange (index) {
      console.log(index)
      this.tskills[index].required = false
      console.log(this.tskills[index])
    },
    mansChange (index) {
      console.log(index)
      this.manskills[index].required = false
      console.log(this.manskills[index])
    },
    manLeadsChange (index) {
      console.log(index)
      this.manLeadskills[index].required = false
      console.log(this.manLeadskills[index])
    },
    getFetchrolename () {
      const mainurl = '/dashboard/get_role_template'
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        console.log(response.data)
        console.log(response)
        var data = response.data.role_template_list
        console.log('rolename', data)
        this.rolelist = data[0].role_name
      }).catch(e => {
        console.log(e)
      })
    },
    getFeedbackDetails () {
      const mainurl = '/dashboard/get_acs_feedback/' + this.schedule_id
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        this.feedbackDetail = response.data.feedback_detail[0]
        this.tskills = response.data.technical_skills
        this.manskills = response.data.mandatory_skills
        this.manLeadskills = response.data.mandatory_lead_skills
        this.postSkills = response.data.post_primaryskills
        this.pfskills = response.data.post_secondaryskills
        this.form.client_name = this.feedbackDetail.client
        this.form.level = this.feedbackDetail.level
        this.form.interview = this.feedbackDetail.interview_round
        this.schedule_codes = response.data.schedule_codes
        console.log(this.feedbackDetail.communication_level)
        this.form.communication_level = this.feedbackDetail.communication_level
        this.communication_level = this.feedbackDetail.communication_level
        this.rating = this.feedbackDetail.communication_level_rating
        this.form.jun_level = this.feedbackDetail.junior_level
        this.form.mid_level = this.feedbackDetail.mid_level
        this.form.sen_level = this.feedbackDetail.senior_level
        this.form.lead = this.feedbackDetail.lead
        this.form.architect_level = this.feedbackDetail.architect_level
        this.form.commun_level_comments = this.feedbackDetail.communication_level_comments
        this.form.technical_obser = this.feedbackDetail.technical_observation
        this.form.anal_prosolving = this.feedbackDetail.analytical_problemsolving
        this.form.attitude = this.feedbackDetail.attitude
        this.form.clar_answer = this.feedbackDetail.clarity_answer
        this.form.recommended_for = this.feedbackDetail.recommended_for
        this.form.final_recommendation = this.feedbackDetail.final_recommendation
        this.form.other_comments = this.feedbackDetail.other_comments
        this.form.TDD_code = this.feedbackDetail.tdd_code
        this.proxyVal = this.feedbackDetail.proxy
        this.candidateshowVal = this.feedbackDetail.candidate_no_show
        this.recommendedVal = this.feedbackDetail.recommended
        console.log(response.data)
        console.log(response)
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white !important;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
.nav-stacked>li.active>a, .nav-stacked>li.active>a:hover {
    background: transparent;
    color:white;
    border-top: 0;
    border-left-color: #5bad2b ;
}
.ml-20 {
  margin-right: 20px;
}
.ml-36 {
  margin-right: 36px;
}
.p-5 {
  padding: 5px;
}
.container {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.download-pdf {
  float: right;
  padding: 0px;
  padding-bottom: 15px;
}
.fontsize {
  font-family: 'Segoe UI';
  font-size: 12px
}
label {
  font-family: 'Segoe UI';
  font-size: 12px
}
b-form-textarea {
  font-family: 'Segoe UI';
  font-size: 12px
}
select {
  font-family: 'Segoe UI';
  font-size: 12px
}
option {
  font-family: 'Segoe UI';
  font-size: 12px
}
.form-control {
    font-size: 12px !important;
}
</style>
